import { apolloProvider } from '@/apollo-provider.js'
import {
  MUTATION_UPSERT_CAMPAIGN_VARIABLES_CONFIGURATION,
  QUERY_GET_CAMPAIGN_VARIABLES_CONFIGURATION,
  QUERY_GET_BALANCE_BY_CHANNEL,
  QUERY_GET_OMNI_CAMPAIGN,
  QUERY_GET_DAYS_ON_OFFERS,
} from '@/modules/maria/campanha-da-maria-v2/graphql'
import { deepDelete } from '@/helpers/deepDelete'

export default {
  async getOmniCampaign({ commit }, variables) {
    try {
      const result = await apolloProvider.defaultClient.query({
        query: QUERY_GET_OMNI_CAMPAIGN,
        variables,
        fetchPolicy: 'no-cache',
      })
      const omniCampaign = result.data.omniCampaign
      commit('SET_OMNI_CAMPAIGN', omniCampaign)
      commit('SET_PREVIOUS_OFFER_SCHEDULES', omniCampaign.offer_schedules || [])
    } catch (error) {
      console.error('Failed to get omni campaign', error)
    }
  },
  setOmniCampaignKey({ commit }, payloadObject) {
    try {
      commit('SET_OMNI_CAMPAIGN_KEY', payloadObject)
    } catch (error) {
      console.error('Failed to set omni campaign key', error)
    }
  },
  setOmniCampaignLimiter({ commit }, value) {
    try {
      commit('SET_OMNI_CAMPAIGN_LIMITER', value)
    } catch (error) {
      console.error('Failed to set omni campaign limiter', error)
    }
  },
  setOmniCampaignBudget({ commit }, payloadObject) {
    try {
      commit('SET_OMNI_CAMPAIGN_BUDGET', payloadObject)
    } catch (error) {
      console.error('Failed to set omni campaign budget', error)
    }
  },
  setProductsSearchValue({ commit }, payload) {
    try {
      commit('SET_SEARCH_PRODUCTS_VALUE', payload)
    } catch (error) {
      console.error('Failed to set search value', error)
    }
  },
  setLoadingAction({ commit }, value) {
    commit('SET_LOADING_ACTION', value)
  },
  setMessagesDispatcherSettingsChannel({ commit }, payload) {
    try {
      commit('SET_MESSAGES_DISPATCHER_SETTINGS_CHANNEL', payload)
    } catch (error) {
      throw new Error('Failed to set messages dispatcher settings channel', error)
    }
  },
  setVariableCharCount({ commit }, { variable, charCount }) {
    try {
      commit('SET_VARIABLE_CHAR_COUNT', { variable, charCount })
    } catch (error) {
      throw new Error('Failed to set variables char count', error)
    }
  },
  setAllChannelsCharCount({ commit }, payload) {
    try {
      commit('SET_ALL_CHANNELS_CHAR_COUNT', payload)
    } catch (error) {
      throw new Error('Failed to set all channels char count', error)
    }
  },
  async getDaysOnOffers({ commit }, variables) {
    try {
      const result = await apolloProvider.defaultClient.query({
        query: QUERY_GET_DAYS_ON_OFFERS,
        variables: {
          input: variables,
        },
        fetchPolicy: 'no-cache',
      })
      const daysOnOffers = result.data.daysOnOffers
      commit('SET_DAYS_ON_OFFERS', daysOnOffers)
    } catch (error) {
      console.error('Failed to get days on offers', error)
    }
  },
  async getAvailableBalance() {
    try {
      const { data } = await apolloProvider.defaultClient.query({
        query: QUERY_GET_BALANCE_BY_CHANNEL,
        fetchPolicy: 'no-cache',
      })
      return data
    } catch (error) {
      console.error('Failed to get available balance', error)
    }
  },
  async upsertCampaignVariablesConfiguration({ commit }, variables) {
    try {
      const result = await apolloProvider.defaultClient.mutate({
        mutation: MUTATION_UPSERT_CAMPAIGN_VARIABLES_CONFIGURATION,
        fetchPolicy: 'no-cache',
        variables: {
          data: variables,
        },
      })
      const { _id, message, status } = result.data.upsertCampaignVariablesConfiguration
      if (status !== 'SUCCESS') {
        throw new Error(`Failed to upsert campaign variables configuration: ${message}`)
      }
      commit('SET_ID_CAMPAIGN_VARIABLES_CONFIGURATION', _id)
    } catch (error) {
      throw new Error('Failed to upsert campaign variables configuration', error)
    }
  },
  async getCampaignVariablesConfiguration({ commit }, variables) {
    try {
      const { campaignVariablesConfiguration } = await apolloProvider.defaultClient
        .query({
          query: QUERY_GET_CAMPAIGN_VARIABLES_CONFIGURATION,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { campaignVariablesConfiguration } }) => {
          return { campaignVariablesConfiguration }
        })

      deepDelete(campaignVariablesConfiguration, '__typename')
      commit('SET_CAMPAIGN_VARIABLES_CONFIGURATION', campaignVariablesConfiguration)
    } catch (error) {
      console.error('Failed to get campaign variables configuration', error)
    }
  },
  setPreviousOfferSchedules({ commit }, offerSchedules) {
    commit('SET_PREVIOUS_OFFER_SCHEDULES', offerSchedules)
  },
}
